import { connect } from 'react-redux';
import {
  getFilterOptions,
  getNumberFuturePtos,
  resetFilters,
  setFilters,
} from '../../store/openOrder';

import FilterPopover from './FilterPopover';

const mapStateToProps = state => ({
  filterOptions: getFilterOptions(state),
  filters: state.pto.openPtos.filters,
  numberFuturePtos: getNumberFuturePtos(state),
  openPtoList: state.pto.openPtos.openPtoList,
});

const mapDispatchToProps = {
  resetFilters,
  setFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterPopover);
